import React, { ComponentProps, FC } from 'react';
import { Trans } from '@lingui/react/macro';

import FaqSection from '@rover/components/src/FaqSection';
import LandingFaqList from '@rover/react-lib/src/pages/landing/components/LandingFaq/LandingFaqList';
import type { ServiceLandingPathDescriptor } from '@rover/shared/js/hooks/useServiceLanding';
import getBrandDisplayName from '@rover/shared/js/utils/getBrandDisplayName';

import { useServiceLandingFaqs } from '../utils/useServiceLandingFaqs';

type ServiceLandingFaqListProps = Omit<
  ComponentProps<typeof LandingFaqList>,
  'faqs' | 'children'
> & {
  descriptor: ServiceLandingPathDescriptor;
  title: React.ReactNode;
};

const ServiceLandingFaqList: FC<ServiceLandingFaqListProps> = ({
  descriptor,
  title,
  ...sectionProps
}) => {
  const faqs = useServiceLandingFaqs(descriptor);

  if (!faqs || faqs.length === 0) return null;
  const brandDisplayName = getBrandDisplayName();

  return (
    <LandingFaqList faqs={faqs} mt="16x" mb="8x" {...sectionProps}>
      <FaqSection.Header variant="heading" webProps={{ responsive: false }}>
        {title}
      </FaqSection.Header>
      <FaqSection.Subheader>
        <Trans>Frequently asked questions about {brandDisplayName}</Trans>
      </FaqSection.Subheader>
    </LandingFaqList>
  );
};

export default ServiceLandingFaqList;
